// import React from "react";

const HeadlineText = ({ name, t }) => {
  switch (name) {
    case "Klimat":
      return t("Klimatpoäng");
    case "Social rättvisa":
      return t("Social rättvisa");
    case "Vatten":
      return t("Vattenpoäng");
    case "Antibiotikaresistens":
      return t("Antibiotikaresistens");
    case "Transport":
      return t("Transportpoäng");
    case "Landanvändning":
      return t("Landanvändning");
    case "Bekämpningsmedel":
      return t("Bekämpningsmedel");
    case "Övergödning":
      return t("Övergödning");
    case "Barnarbete":
      return t("Barnarbete");
    case "Djurvälfärd":
      return t("Djurvälfärd");
    case "Arbetsförhållanden":
      return t("Arbetsförhållanden");
    case "Biologisk mångfald":
      return t("Biologisk mångfald");
    case "Jämlikhet":
      return t("Jämlikhet");
    case "Lokalbefolkning":
      return t("Lokalbefolkning");
    default:
      return name;
  }
};

export default HeadlineText;
